import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import Image from './_image.js'
import ImageButton from './_image-button.js'
import AbsolutePane from './_absolute-pane.js'
import Tooltip from './_tooltip.js'

export default {
  name: 'PageHeader',
  values: {
    style: {
      emptySpacePlaceholder: {
        width: '8px',
        height: undefined,
      },
    },
    headerContainer: {
      configSet: FlexPane,
      configValues: {
        createStackingContext: true,
        style: {
          flexGrow: 0,
          boxSizing: 'border-box',
          alignItems: 'center',
          minHeight: '40px',
        },
      },
    },
    labelContainer: {
      configSet: FlexPane,
      configValues: {},
    },
    label: {
      configSet: Text,
      configValues: {
        truncate: true,
      },
    },
    icon: {
      configSet: Image,
      configValues: {
        style: {
          flexShrink: 0,
          flexBasis: '40px',
          minHeight: '16px',
        },
      },
    },
    backButton: {
      configSet: ImageButton,
      configValues: {
        button: {
          style: {
            base: {
              flexGrow: 0,
              flexShrink: 0,
              flexBasis: '40px',
              alignItems: 'center',
              alignSelf: 'stretch',
            },
          },
        },
        buttonIcon: {
          src: 'controls-chevron-standard-left',
          style: {
            minWidth: '16px',
            minHeight: '16px',
          },
        },
      },
    },
    backgroundImage: {
      configSet: Image,
      configValues: {
        style: {
          width: '100%',
          height: '100%',
        },
      },
    },
    backgroundImageContainer: {
      configSet: AbsolutePane,
      configValues: {
        style: {
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top right',
          width: '25%',
          _mobile_width: undefined,
          height: '100%',
          top: 0,
          right: 0,
        },
      },
    },
    tooltip: {
      configSet: Tooltip,
      configValues: {
        popup: {
          container: {
            style: {
              top: 'calc(100% + 4px)',
              left: '40px',
            },
          },
          arrowhead: {
            direction: 'up',
          },
          arrowheadOffset: '8px',
        },
      },
    },
    sticky: false,
    fixedHeader: {
      configSet: AbsolutePane,
      configValues: {
        fixed: true,
        style: {
          zIndex: 3,
          width: '100%',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
